export const CONTENT_API_ENDPOINT = process.env.CONTENT_API_ENDPOINT || '/';
export const PROFILE_API_ENDPOINT = process.env.PROFILE_API_ENDPOINT || 'https://api-profile.dom.ru';
// @ts-ignore
export const EGP_IMG = ['buildhq', 'production'].includes(process.env.ENVIROMENT)
    ? '/epgservice/ertelecomipfile/pic/'
    : 'http://xmldata.epgservice.ru/EPGService/hs/xmldata/ertelecomipfile/pic/';
export const BILLING_GET_INFO = 'es_webface/web_cabinet.get_info';
export const LK_URL = 'https://lk.dom.ru';
export const API_ENDPOINT_USER_REQUEST = process.env.API_REQUEST_ENDPOINT || 'https://api-request.dom.ru/v1';
export const PROVIDER_API_ENDPOINT = process.env.PROVIDER_API_ENDPOINT || 'https://providers.dom.ru';
export const DOMRUPROFSOFT_API_ENDPOINT = 'http://beta-domru.profsoft.online:8890';

export const IS_EXPORT_ENV = process.env.SERVER_ENV === 'export';
export const IS_SERVER_REQUEST_ENABLED = process.env.SERVER_REQUEST;

// cookies
export const ACCESS_TOKEN_COOKIE = 'ACCESS_TOKEN';
export const REFRESH_TOKEN_COOKIE = 'REFRESH_TOKEN';
export const LK_PHPSESSID = 'LK_PHPSESSID';
export const AGREEMENT_ID_COOKIE = 'userId';
export const WRONG_LOGIN_COUNT_COOKIE = 'wrongLoginCount';
export const CITYDOMAIN_COOKIE = 'citydomain';
export const BILLINGDOMAIN_COOKIE = 'billingDomain';
export const COOKIE_MAX_AGE_LONG = 62 * 24 * 60 * 60;
export const COOKIE_MAX_AGE_SHORT = 15 * 60;
export const COOKIE_DOMAIN = process.env.COOKIE_DOMAIN;
// export const COOKIE_DOMAIN = '.profsoft.online';
export const PRODUCT_TYPE_COOKIE = 'product_type';
export const NOTIFICATION_PPR_COOKIE = 'notificationPprViewed';
export const NOTIFICATION_CRASH_COOKIE = 'notificationCrashViewed';
export const MIGRATION_STATUS_COOKIE = 'migrationStatus';

// localStorage
export const LS_PAY_DATA = 'payData';
export const LS_KEY_PAY = 'keyData';
export const LS_ARCHIVE_PAY = 'archiveData';
export const LS_TARRIFFS_ACTIVE = 'tariffsActive';
export const LS_CATALOG_CART = 'catalogCart';

// billing params
export const CHECK_PRICE_UP = 'check_price_up';
export const CHECK_SERV_REC_CAN_CREATE = 'check_can_service_req_create';
export const CREATE_SERVICE_REQUEST = 'create_service_request_from_lk';
export const DISABLED_VAS_WIZARD = 'disabled_vas_wizard';
export const EVERYWHERE_WATCH_LIST = 'everywhere_watch_list';
export const EVERYWHERE_WATCH_ON = 'everywhere_watch_on';
export const INTERCOM_CONTENT_ACTIVATE = 'intercom_content_activate';

export const DOWNLOAD_VIDEO_SERVICE_ID = 103353;

export const REQUEST_TIMEOUT = 15000;

export const MONTHS = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];

export const MONTHS_GENITIVE = [
    'Января',
    'Февраля',
    'Марта',
    'Апреля',
    'Мая',
    'Июня',
    'Июля',
    'Августа',
    'Сентября',
    'Октября',
    'Ноября',
    'Декабря',
];

export const ERROR_PAYMENT = 'Пожалуйста, проверьте наличие средств на карте и повторите попытку. Или выберите другой способ оплаты.';

export const PRODUCTS = {
    internet: 5,
    tv: 53,
    telephony: 31,
    tvAndInternet: 0,
    content: 67,
    intercom: 75,
    videocontrol: 112,
};

export enum EProductsId {
    internet = 5,
    tv = 53,
    telephony = 31,
    tvAndInternet = '5,53',
    content = 67,
    intercom = 75,
    videocontrol = 112,
}

export const SERVICE = { viewManagement: 11740929 };

export const PATH_IMAGES_FOR_QIUZ = '/static/images/quiz';

// texts
export const SUBTITLE = 'Подключим за 24 часа';

// Mobile
export const MOBILE_OS = { android: 'Android', iphone: 'Ios' };
export const MOBILE_MARKETS = { apn: 'com.ertelecom.agent', isi: '799358248', ibi: 'com.domru.domruagent' };
export const DEEPLINK = 'https://app.dom.ru/?link=';
export const ANDROID_LINK = 'https://app.dom.ru/android';
export const IPHONE_LINK = 'https://app.dom.ru/ios';
export const DEFAULT_LINK = 'https://app.dom.ru/site';

// Максимальная и минимальная оплата
export const MIN_PAYMENT = 10;
export const MAX_PAYMENT = 150000;

// минимальная и максимальная даты приостановления услуг
export const MIN_SUSPEND_DATE = 7;
export const MAX_SUSPEND_DATE = 124;

export const CONTACT_STATUS_CONFIRMED = 'confirmed';
export const CONTACT_STATUS_UNCONFIRMED = 'unconfirmed';

export const IS_PRODUCTION_ENVIROMENT = process.env.ENVIROMENT === 'production';

export const MAX_TRY_LOGIN_COUNT = 5;

// соответствие клиентских сервисов и тегов адреса из апи биллинга
export const SERVICE_MAP = {
    int: [5, 31, 112],
    intercom: [75],
    ktv: [12, 32, 53, 116],
    cktv: [12, 32, 53, 116],
    gs: [5, 31, 112],
};

// AB-тестирование интернет магазин
export const AB_SHOW_SHOP = 'show_shop';
// AB-тестирование новый слайдер
export const AB_NEW_BANNERS_WITH_TABS = 'new_banners_with_tabs';

// Сектор для определения провайдера
export const PROVIDER_SECTOR = 'b2c';
// Оператор для провайдера
export const PROVIDER_OPERATOR = '607711801b4fad6387556c9e';

// Текст для отключения спецпредложений
export const DISCONNECT_TEXT = 'При повторном подключении услуги с вашего счета снова спишется абонентская плата согласно условиям акции.';

// Дефолтный файл оферты
// export const DEFAULT_OFFER_LINK = 'https://cdn-web.ertelecom.ru/content/files/document/d1b0a6a5d180d29452721d1d500980f8.pdf';

export const ICON_TYPES = {
    0: 'None',
    1: 'pdf',
    2: 'xls',
    3: 'docx',
    4: 'txt',
};
